var mainProductTitle; 
var mainProductImage;
var mainProductprice;
jQuery(document).ready(function($){
  // Sheet ID and name
  ///////////////////////////////////////////////////////////////////////////////fetchDataFromGoogleSheet///////////////////////////////////////////////////////////////////////////////
const sheetId = "1NuDyFm0oN0FFk7M1poBsRC4nT0Fhu1LJkCDSRskwNpg";
const sheetName = encodeURIComponent("Cross-Sell Recom.");
// Google Sheet URL
const sheetURL = `https://docs.google.com/spreadsheets/d/${sheetId}/gviz/tq?tqx=out:csv&sheet=${sheetName}`;
  
getProductSku()
// Fetch data from Google Sheet using jQuery
// Function to fetch data from Google Sheet using jQuery
  let globalJsonData = null;
function fetchDataFromGoogleSheet(productId, notFoundCallback) {
  $.ajax({
    url: sheetURL,
    dataType: 'text',
    success: function(data) {
      // Parse CSV data
      const rows = data.split(/\r?\n/);
      console.log('====================')
  console.log(rows)
  console.log('====================')
      let jsonData = []; // JSON variable to store data from CSV

      // Loop through each row of CSV data
      for (let i = 1; i < rows.length; i++) {
        const cols = rows[i].split(',');
        // Create an object for each row with column headers as keys
        let rowData = {
          id: cols[0].replace(/"/g, '').trim(),
          valueB: cols[1].replace(/"/g, '').trim(), // Assuming value in column B
          valueC: cols[2].replace(/"/g, '').trim(), // Assuming value in column C
          valueD: cols[3].replace(/"/g, '').trim()  // Assuming value in column D
        };
        jsonData.push(rowData); // Push the row data object to the JSON array
      }
       globalJsonData = jsonData; 
      console.log("JSON data from CSV:", jsonData); // Log the JSON data
      
      console.log(productId)
      // productId = 'DD-153QMF';
      // Find the row where the product ID matches in column A
      let productIds = null;
      for (let i = 1; i < rows.length; i++) {
        const cols = rows[i].split(',');
        var idA = cols[0].replace(/"/g, '').trim();
        // var idA = parseFloat(cols[0].replace(/"/g, '').trim());
        // productId = typeof productId === 'string' ? parseFloat(productId.replace(/"/g, '').trim()) : productId;
        if (idA === productId) {
          // Extract product IDs from columns B, C, and D
          productIds = cols.slice(1, 4); // Assuming values are in columns B, C, and D
          break;
        }
      }

      if (productIds) {
        // Now you have the values from columns B, C, and D for the matched row
        console.log("Values for matched row:", productIds);
        // const productIds = ['123456', '456789', '987']; // Example product IDs obtained from Google Sheet
        fetchVariantInfoFromShopify(productIds);
        // Your Shopify logic here...
      } else {
        console.log("Product ID not found in Google Sheet.");
        // Execute the notFoundCallback function if provided
        if (typeof notFoundCallback === 'function') {
          notFoundCallback();
        }
      }
    },
    error: function(xhr, status, error) {
      console.error('Error fetching data from Google Sheet:', error);
      console.log('XHR status:', status);
    console.log('XHR response:', xhr.responseText);
    }
  });
}


const productIdToMatch = getProductSku();
fetchDataFromGoogleSheet(productIdToMatch, function() {
  // Logic to execute when the product ID is not found
  console.log("Product ID not found. Performing alternative action...");
});
///////////////////////////////////////////////////////////////////////////////getSKU//////////////////////////////////////////////////////////////////////////////////////
 function getProductSku(){
   let sku = productVal.variants[0].sku;
   mainProductprice = productVal.variants[0].price; 
    return sku; 
}
  console.log(mainProductprice)
  console.log('9999999999999999999999999')
///////////////////////////////////////////////////////////////////////////////getSkuOnVariantClick///////////////////////////////////////////////////////////////////////////////
   
  $("fieldset.js.product-form__input input[type='radio']").on("click", function() {
    setTimeout(function(){
      if ($('.products-container').length) {
          // If it exists, remove it
          $('.products-container').remove();
      }
      if ($('.lds-ring').length) {
          // If it exists, remove it
          $('.lds-ring').remove();
      }
      var varSku = productVal.variants;
            let currentURL = window.location.href;
            let urlObject = new URL(currentURL);
            let variantValue = parseInt(urlObject.searchParams.get("variant"));
      console.log(globalJsonData)
             for (let i = 0; i < varSku.length; i++) {
                if (varSku[i].id === variantValue) {
                    let sku = varSku[i].sku;
                  mainProductprice = varSku[i].price
                  console.log(mainProductprice)
                  console.log(varSku[i])
                  
                    console.log("SKU:", sku);
              
                    // Check if SKU exists in globalJsonData
                    let matchedValues = [];
                    for (let j = 0; j < globalJsonData.length; j++) {
                        if (globalJsonData[j].id === sku) {
                            console.log("SKU exists in globalJsonData.");
                            $('.post_check_main_grid').after('<div class="lds-ring"><span></span><span></span><span></span><span></span></div>')
                            matchedValues.push(globalJsonData[j].valueB);
                            matchedValues.push(globalJsonData[j].valueC);
                            matchedValues.push(globalJsonData[j].valueD);
                          $('.products-container').remove();
                          fetchVariantInfoFromShopify(matchedValues);
                          break;
                            // break;
                        }
                    }
                  
                    console.log("Matched Values:", matchedValues);
                    // return matchedValues;
                }
              }
      
      console.log(variantValue)
      console.log(varSku)
      console.log(globalJsonData)
    }, 500);
  });

///////////////////////////////////////////////////////////////////////////////getProductInfo///////////////////////////////////////////////////////////////////////////////
  // Replace 'YOUR_SHOPIFY_STORE_URL' with your actual Shopify store URL
  const shopifyStoreURL = 'https://lifely.com.au';

  // Replace 'YOUR_STOREFRONT_ACCESS_TOKEN' with your actual Storefront API access token
  const storefrontAccessToken = '28e2893e9acbe4ab0daf89709db03cc3';
  
 // Function to get product collections by product title
  function fetchVariantInfoFromShopify(productIds) {
    // Shopify Storefront API endpoint for fetching collections
    const apiEndpoint = `${shopifyStoreURL}/api/2023-07/graphql.json`;

    // GraphQL query to get collections containing the specified product title
    const graphqlQuery = `
      query {
              products(first: 150) {
                edges {
                  node {
                    id
                    title
                    onlineStoreUrl
                    variants(first: 25) {
                      edges {
                        node {
                          id
                          sku
                          title
                          price {
                            amount
                            currencyCode
                          }
                          compareAtPrice {
                            amount
                            currencyCode
                          }
                          image {
                            originalSrc
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
    `;
console.log('88888888888888888888888888888888888888888')
    // Make the API request
   // Make the API request
    $.ajax({
      type: 'POST',
      url: apiEndpoint,
      headers: {
        'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
        'Content-Type': 'application/json',
      },
      data: JSON.stringify({ query: graphqlQuery }),
      success: function (response) {
        // Check if the expected properties exist before accessing them
        const products = response.data.products.edges;
        console.log(products)
        // Iterate through each product
       // Define a variable to store the HTML content
      let productHTMLContent = '';
      
      products.forEach(productEdge => {
          const productNode = productEdge.node;
          const productId = productNode.id;
          const productTitle = productNode.title;
          const productUrl = productNode.onlineStoreUrl;
        
      
          // Iterate through variants of each product
          const variants = productNode.variants.edges;
          variants.forEach(variantEdge => {
              const variantNode = variantEdge.node;
              const variantId = variantNode.id.split('/').pop(); // Extract numeric ID from the 'gid://shopify/ProductVariant/' format
              const variantTitle = variantNode.title;
              let variantPrice = variantNode.price['amount'];
              let variantPriceO = variantNode.price['amount'];
              const variantImage = variantNode.image ? variantNode.image.originalSrc : '';
              const variantOriginalPrice = variantNode.compareAtPrice;
            const variantSKU = variantNode.sku;
              // console.log(variantSKU)
              // console.log('*****************************************')
              let productIdsArray = productIds;
              // Remove double quotes from each element in the array
              productIdsArray = productIdsArray.map(id => id.replace(/"/g, ''));
              // console.log(productIdsArray)
            if (productIdsArray.some(id => id.trim() !== "")) {
              if (productIdsArray.includes(variantSKU)) {
                variantPrice = (variantPrice * 75) / 100;
                let formattedPrice = variantPrice.toFixed(2);

                  // console.log(variantNode.compareAtPrice.amount);
                  console.log('Matched Variant Id: ', variantId);
                  console.log('Matched Variant Title:', variantTitle);
                  console.log('Matched Variant Title:', variantImage);
                  
                  // Construct the product variant URL
                  var productVariantUrl = "" + productUrl + "?variant=" + variantId;
                                  console.log('================================')
                console.log(productVariantUrl)
                console.log('================================')                
                  // Append the HTML content for each product to the productHTMLContent variable
                  productHTMLContent += `
                      <label>
                          <input type="checkbox" name="addons" class="additional-product" id="product${variantId}" value="${variantId}" data-price="${formattedPrice}" data-priceO="${variantPriceO}">
                          <div class="product-img"><img src="${variantImage}" height="25px" width="25px"><svg class="plus-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 3.80005V12.2" stroke="#2C474B" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><path d="M8 3.80005V12.2" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M3.80005 8H12.2" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>
                          <h2 class="product-title">${productTitle} ${variantTitle} </h2><span>$${formattedPrice}</span>
                          <a href="${productVariantUrl}" target="_blank">View Product</a>
                      </label>
                  `;
              }
            }
          });
      });
      if (productHTMLContent.trim() !== "") {
        // Create a div element with a title and append the productHTMLContent to it
        var bundle_left_cart_icon = '<svg width="31" height="20" viewBox="0 0 31 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M30.2617 12.5918L28.1586 9.58377C27.9888 9.34226 27.7628 9.14492 27.4998 9.00847C27.2368 8.87202 26.9446 8.80048 26.6479 8.79991H24.4065C24.2729 8.79991 24.1449 8.74726 24.0504 8.65355C23.956 8.55983 23.9029 8.43273 23.9029 8.3002V1.44139C23.9029 1.33763 23.8822 1.23489 23.8419 1.13914C23.8016 1.0434 23.7425 0.956545 23.6681 0.883627C23.5937 0.810709 23.5054 0.753176 23.4085 0.714364C23.3115 0.675552 23.2077 0.656235 23.1031 0.657532H9.49698C9.39242 0.656235 9.28864 0.675552 9.19166 0.714364C9.09468 0.753176 9.00643 0.810709 8.93203 0.883627C8.85764 0.956545 8.79857 1.0434 8.75826 1.13914C8.71794 1.23489 8.69719 1.33763 8.6972 1.44139V4.26826L4.20123 4.26826C3.66578 4.26826 3.23171 4.70233 3.23171 5.23777C3.23171 5.77322 3.66578 6.20729 4.20123 6.20729H6.30498C6.3075 6.20727 6.31001 6.20726 6.31254 6.20726L8.68247 6.20726C8.68502 6.20726 8.68757 6.20727 8.69012 6.20729H8.6972V6.20737C9.22585 6.21525 9.65198 6.64625 9.65198 7.17678C9.65198 7.70731 9.22585 8.13831 8.6972 8.14619V8.14633L6.14026 8.14633C5.60481 8.14633 5.17075 8.58039 5.17075 9.11584C5.17075 9.65129 5.60481 10.0854 6.14026 10.0854H8.6972V10.0854H10.8802C11.4156 10.0854 11.8497 10.5195 11.8497 11.0549C11.8497 11.5904 11.4156 12.0244 10.8802 12.0244L7.00212 12.0244L6.99322 12.0244H4.84759C4.31214 12.0244 3.87807 12.4585 3.87807 12.9939C3.87807 13.5294 4.31214 13.9634 4.84759 13.9634H8.6972V16.5112C8.69719 16.6149 8.71794 16.7177 8.75826 16.8134C8.79857 16.9092 8.85764 16.996 8.93203 17.0689C9.00643 17.1418 9.09468 17.1994 9.19166 17.2382C9.28864 17.277 9.39242 17.2963 9.49698 17.295H29.2447C29.4543 17.2963 29.662 17.2565 29.8561 17.1778C30.0501 17.0991 30.2265 16.9831 30.3751 16.8365C30.5238 16.6898 30.6418 16.5155 30.7223 16.3235C30.8028 16.1314 30.8442 15.9255 30.8442 15.7175V14.2674C30.8284 13.6627 30.625 13.0776 30.2617 12.5918ZM21.4443 6.0074L19.361 5.89962L20.1904 7.03622C20.25 7.14509 20.2658 7.27234 20.2347 7.39234C20.2035 7.51233 20.1277 7.61616 20.0225 7.6829C19.9146 7.74013 19.7886 7.75373 19.6708 7.72086C19.553 7.68799 19.4526 7.61119 19.3906 7.50654C19.2523 7.33017 19.1141 7.144 18.9857 6.95783C18.9857 7.27667 18.9642 7.59195 18.9428 7.90582V7.90586V7.90589V7.90593V7.90596C18.9287 8.1129 18.9146 8.31923 18.9068 8.52556C18.887 9.04487 17.9194 9.13305 17.9786 8.52556C18.0159 8.14314 18.0336 7.67142 18.0515 7.19595L18.0515 7.19579L18.0515 7.19565L18.0515 7.19554L18.0515 7.19545C18.062 6.91578 18.0726 6.63477 18.0872 6.36993C17.6923 6.75533 17.3072 7.15706 16.932 7.57512C16.8435 7.66071 16.7248 7.70861 16.6012 7.70861C16.4776 7.70861 16.3589 7.66071 16.2704 7.57512C16.1872 7.48191 16.1412 7.36166 16.1412 7.23708C16.1412 7.11251 16.1872 6.99225 16.2704 6.89904C16.616 6.52671 16.9616 6.15437 17.3171 5.80163L16.0433 5.73304C15.4509 5.73304 15.4509 4.75322 16.0433 4.75322L17.4948 4.861L16.695 3.83218C16.6626 3.77943 16.6409 3.72085 16.6313 3.6598C16.6217 3.59874 16.6243 3.5364 16.639 3.47634C16.6536 3.41629 16.6801 3.35969 16.7168 3.30978C16.7535 3.25987 16.7998 3.21764 16.853 3.18549C16.9624 3.12774 17.0899 3.11385 17.2093 3.14666C17.3287 3.17947 17.4309 3.2565 17.4948 3.36186L18.1958 4.34169C18.1958 3.78319 18.1958 3.21488 18.2748 2.65638C18.3538 2.09788 19.2622 2.04889 19.203 2.65638C19.1654 3.04168 19.1556 3.36391 19.1459 3.68307C19.1404 3.86713 19.1348 4.05018 19.124 4.24371C19.5486 3.91056 19.983 3.58722 20.4372 3.26388C20.4894 3.23254 20.5475 3.21197 20.6079 3.20339C20.6683 3.19481 20.7298 3.19841 20.7888 3.21395C20.8478 3.2295 20.903 3.25669 20.9512 3.29388C20.9993 3.33108 21.0395 3.37752 21.0691 3.43045C21.1287 3.53932 21.1446 3.66657 21.1134 3.78657C21.0823 3.90656 21.0065 4.01039 20.9013 4.07713C20.4866 4.36128 20.0719 4.66503 19.6769 4.97858L21.4443 5.05696C22.0368 5.09616 22.0368 6.03679 21.4443 6.0074ZM0.969517 12.0244C0.434068 12.0244 0 12.4585 0 12.9939C0 13.5294 0.434068 13.9634 0.969517 13.9634H1.83131C2.36676 13.9634 2.80083 13.5294 2.80083 12.9939C2.80083 12.4585 2.36676 12.0244 1.83131 12.0244H0.969517Z" fill="#2C474B"/><g clip-path="url(#clip0_659_26167)"><path d="M13.111 18.5297C12.8723 18.5316 12.6384 18.4631 12.4391 18.333C12.2397 18.2028 12.0837 18.0168 11.991 17.7986C11.8983 17.5803 11.8731 17.3396 11.9184 17.1071C11.9638 16.8746 12.0777 16.6607 12.2458 16.4925C12.4139 16.3244 12.6285 16.2095 12.8624 16.1626C13.0964 16.1157 13.3391 16.1388 13.5598 16.229C13.7805 16.3191 13.9692 16.4723 14.102 16.6691C14.2348 16.8659 14.3057 17.0974 14.3057 17.3343C14.3057 17.6496 14.1802 17.9522 13.9564 18.1761C13.7326 18.4 13.4287 18.5271 13.111 18.5297Z" fill="#1E2229"/><path d="M13.1108 14.6787C12.5788 14.6768 12.0582 14.8317 11.615 15.1238C11.1719 15.4159 10.8261 15.832 10.6216 16.3194C10.4171 16.8068 10.3631 17.3435 10.4664 17.8614C10.5697 18.3793 10.8257 18.8551 11.2019 19.2284C11.5781 19.6017 12.0575 19.8557 12.5794 19.9582C13.1013 20.0608 13.6421 20.0072 14.1333 19.8042C14.6244 19.6013 15.0438 19.2582 15.3381 18.8184C15.6325 18.3786 15.7886 17.862 15.7866 17.3341C15.7866 16.6298 15.5047 15.9544 15.0029 15.4565C14.5011 14.9585 13.8205 14.6787 13.1108 14.6787Z" fill="#1E2229"/><path d="M24.8805 18.5297C24.6418 18.5316 24.408 18.4631 24.2086 18.333C24.0092 18.2028 23.8533 18.0168 23.7606 17.7986C23.6679 17.5803 23.6426 17.3396 23.688 17.1071C23.7333 16.8746 23.8473 16.6607 24.0153 16.4925C24.1834 16.3244 24.398 16.2095 24.632 16.1626C24.8659 16.1157 25.1086 16.1388 25.3293 16.229C25.55 16.3191 25.7387 16.4723 25.8715 16.6691C26.0043 16.8659 26.0752 17.0974 26.0752 17.3343C26.0752 17.6496 25.9497 17.9522 25.7259 18.1761C25.5021 18.4 25.1983 18.5271 24.8805 18.5297Z" fill="#1E2229"/><path d="M24.8804 14.6787C24.3483 14.6768 23.8277 14.8317 23.3846 15.1238C22.9414 15.4159 22.5956 15.832 22.3911 16.3194C22.1866 16.8068 22.1326 17.3435 22.2359 17.8614C22.3393 18.3793 22.5952 18.8551 22.9714 19.2284C23.3476 19.6017 23.8271 19.8557 24.349 19.9582C24.8709 20.0608 25.4117 20.0072 25.9028 19.8042C26.394 19.6013 26.8133 19.2582 27.1077 18.8184C27.402 18.3786 27.5581 17.862 27.5562 17.3341C27.5562 16.6298 27.2743 15.9544 26.7724 15.4565C26.2706 14.9585 25.59 14.6787 24.8804 14.6787Z" fill="#1E2229"/></g><defs><clipPath id="clip0_659_26167"><rect width="22.0977" height="19.3712" fill="white" transform="translate(8.69727 0.62793)"/></clipPath></defs></svg>';
        const productsDiv = $('<div>').addClass('products-container').html(`<div class="bunddle-top-header"><h2><span class='left-bundle-cart-icon'>${bundle_left_cart_icon}</span>Complete the look </h2></div><div class="product-card">${productHTMLContent}</div>`);      
        // Append the div containing all products to the desired location
        $('.post_check_main_grid').after(productsDiv);
      }
        console.log(response)
        $('.lds-ring').remove();
      },
      error: function (error) {
        console.error('Error fetching product collections:', error);
      },
    });
  }
///////////////////////////////////////////////////////////////////////////////addToCart///////////////////////////////////////////////////////////////////////////////
   $('#product_detail_custom_add_to_cart').on('click', function(event) {
      // Check if the variant is available
         if ($('.product__info-container fieldset.js.product-form__input input[type="radio"]').length > 0) {
          // At least one radio button is present
          // Check if none of the radio buttons within the container are checked
          if ($('.product__info-container fieldset.js.product-form__input input[type="radio"]:checked').length === 0) {
              console.log("None of the radio buttons within the specified container are checked.");
            
              // Perform your actions here if none of the radio buttons are checked
          } else {
              console.log("At least one radio button within the specified container is checked.");
              // Perform your actions here if at least one radio button is checked
                var selectedAdditionalProductIds = [];
                
                // Iterate through each checked checkbox and push its value to the array
                $('.additional-product:checked').each(function() {
                    selectedAdditionalProductIds.push($(this).val());
                });
            
                console.log(selectedAdditionalProductIds); // Debugging output
                setTimeout(function(){
                  // addToCart function with selectedAdditionalProductIds
                  addToCart(selectedAdditionalProductIds, 1); // Adjust quantity if needed
                }, 500)
          }
      } else {
          // No radio buttons found within the specified container
          console.log("No radio buttons found within the specified container.");
               var selectedAdditionalProductIds = [];
              // Iterate through each checked checkbox and push its value to the array
              $('.additional-product:checked').each(function() {
                  selectedAdditionalProductIds.push($(this).val());
              });
          
              console.log(selectedAdditionalProductIds); // Debugging output
              setTimeout(function(){
                // addToCart function with selectedAdditionalProductIds
                addToCart(selectedAdditionalProductIds, 1); // Adjust quantity if needed
              }, 500)
      }
    });

function addToCart(selectedProductIds, quantity) {
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
            items: selectedProductIds.map(function(productId) {
                return {
                    quantity: quantity,
                    id: productId
                };
            })
        },
        dataType: 'json',
        success: function(response) {
          console.log(response)
            // Optionally, you can handle success actions here
            console.log('Products added to cart successfully!');
        },
        error: function(XMLHttpRequest, textStatus, errorThrown) {
            console.log('Error adding products to cart:', errorThrown);
        }
    });
}
///////////////////////////////////////////////////////////////////////////////sticky_add_to_cart_bautton///////////////////////////////////////////////////////////////////////////////
  $('body').on('click', '#sticky_add_to_cart_bautton', function(){
    var selectedAdditionalProductIds = [];
    console.log('stikyyyyyyyyyyyyyyyyyyyyyyy')
    
    // Iterate through each checked checkbox and push its value to the array
    $('.additional-product:checked').each(function() {
        selectedAdditionalProductIds.push($(this).val());
    });

    console.log(selectedAdditionalProductIds); // Debugging output
    setTimeout(function(){
      
    
    // Now call the addToCart function with selectedAdditionalProductIds
    addToCart(selectedAdditionalProductIds, 1); // Adjust quantity if needed
      }, 500)
  })
///////////////////////////////////////////////////////////////////////////////calculatePrice///////////////////////////////////////////////////////////////////////////////
 // Function to calculate sale price, original price, and selected items count
    mainProductTitle = $('.main-product-title-desktop .product__title').text().trim();
    mainProductImage = $('.product__modal-opener .product__media img').attr('src');
   var originalMainProductPrice = mainProductprice; // Preserve the original price

    function calculatePrices() {
    var totalPrice = 0;
    var originalPrice = 0;
    var selectedCount = $('.additional-product:checked').length;
    var priceO = 0;
    var price = 0;

    // Loop through checked checkboxes
    $('.additional-product:checked').each(function() {
        // Get price from data attribute
        price = parseFloat($(this).data('price'));
        priceO = parseFloat($(this).data('priceo'));

        totalPrice += price;
        originalPrice += priceO;
    });

    // Add main product's original price to originalPrice
    originalPrice += originalMainProductPrice / 100;

    // Calculate the discounted main product price
    var discountedMainProductPrice = originalMainProductPrice * 0.75;
    
    // Calculate formatted prices
    var formattedOriginalMainProductPrice = (originalMainProductPrice / 100).toFixed(2);
    var formattedDiscountedMainProductPrice = (discountedMainProductPrice / 100).toFixed(2);

    // Add the discounted main product price to the total price
    totalPrice += parseFloat(formattedDiscountedMainProductPrice);

    // Display sale price, original price, and selected items count
    console.log(selectedCount + " selected item(s)");
    console.log("Sale Price: $" + totalPrice.toFixed(2));
    console.log("Original Price: $" + originalPrice.toFixed(2));

    if (selectedCount >= 1) {
        $('.combo-price-section').remove();
        $('.bundle-atc-wrapper').remove();

        // HTML to be appended
        var newHTML = '<div class="combo-price-section">';
        newHTML += '<div class="left-content">';
        newHTML += '<img src="' + mainProductImage + '" alt="Product Image" height="50px" width="50px">';
        newHTML += '<p>' + mainProductTitle + '</p>';
        newHTML += '</div>';
        newHTML += '<p class="addition-class"> + </p>';
        newHTML += '<div class="right-content selected-tems-wrapper">';
        newHTML += '<p class="selected-temss-count">' + selectedCount + ' selected items</p>';
        newHTML += '<p class="bundle-Sale-price">$' + totalPrice.toFixed(2) + '</p>';
        newHTML += '<p class="bundle-original-price">$' + originalPrice.toFixed(2) + '</p>';
        newHTML += '</div>';
        newHTML += '</div>';

        // Append the HTML to .products-container
        $('.products-container').append(newHTML);
        $('.products-container').after('<div class="bundle-atc-wrapper"><a href="javascript:void(0)" class="bundle-atc">Add to cart</a></div>');
    } else {
        $('.combo-price-section').remove();
    }
}

    // Event listener for checkbox click
  $('body').on('change', '.additional-product', function(){
    // $('.additional-product').on('change', function() {
        calculatePrices();
    });
////////////////////////////////////////////////////////////BundleAddToCart/////////////////////////////////////////////
  $('body').on('click', '.bundle-atc', function(){
    console.log('Bundle Clickeddddddddddddddddddddddddddd')
    $('#product_detail_custom_add_to_cart').trigger('click')
  })
  //////////////////////////////////////////////////////////Check variants from url//////////////////////////////////////////
  console.log(productVal)
  console.log('---------------------------------------')
  function getParameterByName(name, url) {
                if (!url) url = window.location.href;
                name = name.replace(/[\[\]]/g, "\\$&");
                var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                    results = regex.exec(url);
                if (!results) return null;
                if (!results[2]) return '';
                return decodeURIComponent(results[2].replace(/\+/g, " "));
            }

            var variantId = getParameterByName('variant');
            var foundVariant = null;
  
  var variants = productVal.variants;
  $.each(variants, function(index, variant) {
    // Check if the current variant's ID matches the target ID
    // console.log(typeof variant.id)
    // console.log(typeof variantId)
    if (variant.id.toString() === variantId) {
        // Variant found, do something with it
        console.log("Variant found:", variant.title);
      foundVariant = variant;
        // You can access variant properties like variant.title, variant.price, etc.
    }
});
  
  console.log(variants)
})